<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>门店进销存管理</el-breadcrumb-item>
      <el-breadcrumb-item>费用录入</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.jigouid" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDian"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.leibie" placeholder="请选择费用类别">
              <el-option
                v-for="item in RuiShiLiYanKeMenDianFeiYongLeiBie"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
          <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table v-loading="loading" :data="dataList" border stripe >
          <el-table-column prop="Jigouname" label="归属机构" min-width="15%"></el-table-column>
          <el-table-column prop="Riqi" label="日期" min-width="10%"></el-table-column>
          <el-table-column prop="Leibiename" label="类别" min-width="10%"></el-table-column>
          <el-table-column prop="Amount" label="金额" min-width="9%"></el-table-column>
          <el-table-column prop="Beizhu" label="备注" min-width="9%"></el-table-column>
          <el-table-column prop="CreateTime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column label="操作" min-width="10%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goModifyDeviceInformation(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addForm" ref="addFormRef" label-width="90px">
          <el-form-item label="归属机构" class="addAdminForm">
            <el-select v-model="addForm.jigouid" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDian"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期" class="addAdminForm">
            <el-date-picker v-model="addForm.riqi" type="date" placeholder="日期" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="类别" class="addAdminForm">
            <el-select v-model="addForm.leibie" placeholder="请选择">
              <el-option
                v-for="item in RuiShiLiYanKeMenDianFeiYongLeiBie"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="金额" class="addAdminForm">
            <el-input v-model="addForm.amount" placeholder="请输入金额"></el-input>
          </el-form-item>
          <el-form-item label="备注" class="addAdminForm">
            <el-input v-model="addForm.beizhu" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="BackToFirst">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <MenDianPurchaseSalesFeiYongLuRuEdit ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></MenDianPurchaseSalesFeiYongLuRuEdit>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import MenDianPurchaseSalesFeiYongLuRuEdit from '@/componentsSubVue/MenDianPurchaseSalesFeiYongLuRuEdit.vue'
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    MenDianPurchaseSalesFeiYongLuRuEdit,
    TencentyunCosUploadExcel
  },
  name: 'MyMenDianPurchaseSalesFeiYongLuRu',
  data () {
    return {
      loading: false,
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 查询客户
      keywords: {
        jigouid: '-1',
        jigouname: '',
        leibie: '-1',
        begintime: '',
        endtime: ''
      },
      // 添加
      addForm: {
        jigouid: '-1',
        jigouname: '',
        riqi: '',
        leibie: '',
        amount: '0',
        beizhu: ''
      },
      RuiShiLiYanKeMenDian:[],
      RuiShiLiYanKeMenDianFeiYongLeiBie:[],
    }
  },
  mounted () {
    this.RuiShiLiYanKeMenDian = Vue.prototype.FunGetRuiShiLiYanKeMenDian()
    this.RuiShiLiYanKeMenDianFeiYongLeiBie = Vue.prototype.FunGetRuiShiLiYanKeMenDianFeiYongLeiBie()
    this.apiGetMenDianPurchaseSalesFeiYongLuRuNum()
    this.apiGetMenDianPurchaseSalesFeiYongLuRuList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apiGetMenDianPurchaseSalesFeiYongLuRuNum()
      this.apiGetMenDianPurchaseSalesFeiYongLuRuList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetMenDianPurchaseSalesFeiYongLuRuList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetMenDianPurchaseSalesFeiYongLuRuNum()
      this.apiGetMenDianPurchaseSalesFeiYongLuRuList()
    },
    clickadd () {
      this.apiAddMenDianPurchaseSalesFeiYongLuRu()
    },
    // 修改
    goModifyDeviceInformation (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    // 删除
    clickDelete (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteMenDianPurchaseSalesFeiYongLuRu(row.Id)
      })
    },
    apiGetMenDianPurchaseSalesFeiYongLuRuList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        jigouid: that.keywords.jigouid,
        leibie: that.keywords.leibie,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMenDianPurchaseSalesFeiYongLuRuList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apiGetMenDianPurchaseSalesFeiYongLuRuNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.keywords.jigouid,
        leibie: that.keywords.leibie,
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetMenDianPurchaseSalesFeiYongLuRuNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddMenDianPurchaseSalesFeiYongLuRu: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.addForm.jigouid,
        riqi: that.addForm.riqi,
        leibie: that.addForm.leibie,
        amount: that.addForm.amount,
        beizhu: that.addForm.beizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddMenDianPurchaseSalesFeiYongLuRu, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addForm.jigouid = '-1'
            that.addForm.jigouname = ''
            that.addForm.riqi = ''
            that.addForm.leibie = ''
            that.addForm.amount = '0'
            that.addForm.beizhu = ''

            that.apiGetMenDianPurchaseSalesFeiYongLuRuNum()
            that.apiGetMenDianPurchaseSalesFeiYongLuRuList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeleteMenDianPurchaseSalesFeiYongLuRu: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteMenDianPurchaseSalesFeiYongLuRu, Qs.stringify(data))
        .then(function (response) {
          that.apiGetMenDianPurchaseSalesFeiYongLuRuNum()
          that.apiGetMenDianPurchaseSalesFeiYongLuRuList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
